import { RouterProvider } from 'react-router-dom'
import { Toaster } from 'sonner'
import { router } from '@/app/router'
import { BootstrapGate } from '@/components/auth/bootstrap-gate'
import { useAppDispatch, useAppSelector } from '@/app/hooks'
import { useEffect } from 'react'
import { I18nProvider } from '@/lib/i18n'
import { catalogs } from '@/lib/locales'
import { BrandingSync } from '@/components/shared/branding-sync'
import { logout } from '@/features/auth/auth-slice'

function ThemeSync() {
  const theme = useAppSelector((s) => s.ui.theme)
  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark')
  }, [theme])
  return null
}

/**
 * Listen for cross-tab logout. If another tab clears the access token,
 * this tab dispatches logout too so we don't keep showing authenticated UI
 * with no token.
 */
function CrossTabAuthSync() {
  const dispatch = useAppDispatch()
  useEffect(() => {
    function handler(e: StorageEvent) {
      if (e.key === 'distroops.access_token' && e.newValue === null) {
        dispatch(logout())
      }
    }
    window.addEventListener('storage', handler)
    return () => window.removeEventListener('storage', handler)
  }, [dispatch])
  return null
}

export function App() {
  return (
    <I18nProvider catalogs={catalogs}>
      <BootstrapGate>
        <ThemeSync />
        <CrossTabAuthSync />
        <BrandingSync />
        <RouterProvider router={router} />
        <Toaster position="top-right" richColors closeButton />
      </BootstrapGate>
    </I18nProvider>
  )
}
